export default __webpack_public_path__ + "ebdf5e2ec01b168f6b1feb5f39860b95.svg";